// Inline developer-feedback POST helper for the dogfooding affordance on
// assistant bubbles. The endpoint dual-writes a `developer_feedback` event
// (audit log) and a row in `nadia2_developerfeedback` (read model). The CLI
// `just nadia2-feedback` reads the latter.

import { fetchApi } from "~vue/api";

export type FeedbackVerdict = "good" | "bad" | "note";

export interface CreateFeedbackPayload {
    feedbackText: string;
    targetEventId?: string | null;
    verdict?: FeedbackVerdict | null;
}

export interface CreateFeedbackResponse {
    id: string;
    event_id: string;
    created_at: string;
}

export const submitFeedback = async (conversationId: string, payload: CreateFeedbackPayload): Promise<CreateFeedbackResponse> => {
    const response = await fetchApi(`/v1/nadia2/conversations/${conversationId}/feedback`, {
        method: "POST",
        body: JSON.stringify({
            feedback_text: payload.feedbackText,
            target_event_id: payload.targetEventId ?? null,
            verdict: payload.verdict ?? null,
        }),
    });
    if (!response.ok) {
        const text = await response.text().catch(() => response.statusText);
        throw new Error(`Feedback submit failed: HTTP ${response.status} ${text}`);
    }
    return (await response.json()) as CreateFeedbackResponse;
};
